const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';
const CSS_CHUNK_LOAD_FAILURE_CODE = 'CSS_CHUNK_LOAD_FAILED';
const CHUNK_LOAD_FAILURE_MESSAGE = /Loading (?:CSS )?chunk \S+ failed/i;

export function isPageLoadFailureMessage(message) {
    return typeof message === 'string' && CHUNK_LOAD_FAILURE_MESSAGE.test(message);
}

function isPageLoadFailure(error) {
    if (error === null || typeof error !== 'object') {
        return false;
    }

    return error.name === CHUNK_LOAD_ERROR_NAME
        || error.code === CSS_CHUNK_LOAD_FAILURE_CODE
        || isPageLoadFailureMessage(error.message);
}

export default isPageLoadFailure;
